import React from "react"
import {Image} from "./component"

type PromoIconProps = {
    title: string
    iconSrc: string
    isFirstElement: boolean
}

const PromoIcon = ({iconSrc, title, isFirstElement}: PromoIconProps) => {
    return <Image src={iconSrc} alt={`${title} promotional icon`} isFirstElement={isFirstElement} />
}

export default PromoIcon
